import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { Code, OrderedList, SubSubSectionHeader } from "./components/styled";
import { URLVerification } from "./components/utms";
import { VideoContent } from "./components/video-content";
import { type PlatformDetails } from "./platform-details";

const PLATFORM = Platform.SNAPCHAT;

export const SnapchatDetails: PlatformDetails = {
  northbeamDocUrl: "https://docs.northbeam.io/docs/tracking-for-snapchat-ads",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What does the integration do?",
      content:
        /* eslint-disable max-len */
        "Northbeam natively integrates with the Snapchat Ads API. By doing so, we pull all your current and historical Campaigns, Adsets, and Ads from your account, along with a list of useful metrics. Notably, we pull impressions, which fuel our view model and unlock our Clicks + Modeled Views attribution model. We also pull ad spend and list of in-platform conversion & creative metrics to help you with decision making.",
    },
  ],
};

export const SnapchatSetup = ({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) => (
  <>
    <SetupSection title="Log into Snapchat to connect integration">
      {connectionContent}
    </SetupSection>
    <SetupSection title="Follow the instructions in the video below to update UTMs">
      <VideoContent
        title="Learn how to structure Snapchat UTMs"
        videoUrl="https://www.youtube.com/embed/bnjQpwazReA?si=0DsJF0oyXNczxb8p"
        platform={PLATFORM}
      />
      <div className="flex flex-col gap-2">
        <SubSubSectionHeader>
          Make sure you’ve followed these steps:
        </SubSubSectionHeader>
        <OrderedList variant="upper-alpha">
          <>Navigate to your ad details</>
          <>Click ‘Build a URL Parameter’</>
          <>Scroll to ‘Custom Parameters’</>
          <>
            Insert the following name and value
            <div className="mt-2 ml-[28px]">
              <div className="flex gap-2">
                <span>1da.</span>
                <span>Parameter Name:</span>
                <Code>nbt</Code>
              </div>
              <div className="flex gap-2">
                <span>1db.</span>
                <span>Parameter Value:</span>
                <Code>
                  {
                    "nb:snapchat:{{site_source_name}}:{{campaign.id}}:{{adSet.id}}:{{ad.id}}"
                  }
                </Code>
              </div>
            </div>
          </>
          <>Click ‘Publish’</>
        </OrderedList>
      </div>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
